/**
 * Get station id for recommendation
 *
 * @package ARS Webapp
 * @author René Schulze <schulze@thadeus-roth.de>
 */

import store from '?/Stores';
import router from '?/Router/Webapp';


/**
 * Get station id for recommendation
 *
 * @return {int|null} Station id
 */
export const getStationIdForRecommendation = () => {
    // Try to find an activated station
    if (store.getters.currentStationId) {
        return store.getters.currentStationId;
    }

    // Try to find the last active station
    if (store.getters.lastActiveStationId) {
        return store.getters.lastActiveStationId;
    }

    // Try to find an open single station
    if (
        router.currentRoute.value.meta.scope === 'SingleStation' &&
        router.currentRoute.value.params.id
    ) {
        return router.currentRoute.value.params.id;
    }

    return null;
};
